export interface IWebsiteInstallCloneForm {
  websiteId: string;
  region: string;
  subdomain: string;
  dataCenter: string;
  websiteUrl: string;
}

export interface IWebsiteInstallCloneData {
  region: string;
  subdomain: string;
  dataCenter: string;
  websiteUrl: string;
}

export class WebsiteInstallCloneData implements IWebsiteInstallCloneData {

  region: string;
  subdomain: string;
  dataCenter: string;
  websiteUrl: string;

  constructor(websiteData: IWebsiteInstallCloneForm) {
    this.region = websiteData.region;
    this.subdomain = websiteData.subdomain;
    this.websiteUrl = websiteData.websiteUrl;
    this.dataCenter = websiteData.dataCenter;
  }
}
